import { render, staticRenderFns } from "./PlayerDetail.vue?vue&type=template&id=40bbc831&scoped=true"
import script from "./PlayerDetail.vue?vue&type=script&lang=js"
export * from "./PlayerDetail.vue?vue&type=script&lang=js"
import style0 from "./PlayerDetail.vue?vue&type=style&index=0&id=40bbc831&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bbc831",
  null
  
)

export default component.exports